export const SettingsMapper = {
  hydrate: ({ ...data }) => ({
    otp_delay_seconds: +data.otp_delay_seconds || 60,
    otp_max_attempts_delay_seconds: +data.otp_max_attempts_delay_minuts * 60 || 300,
  }),
};
